export enum EIdFormat {
    FIELD = "field",
    BUTTON = "button",
}

export const formatId = (value: string, format: EIdFormat) => `${format}-${value.toLowerCase().replace(/\s+/g, "-")}`;
